module.exports = __webpack_public_path__ + "img/icon-1.9d161207.png";